import React, { useEffect, useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
import FormNuevaCita from "./FormNuevaCita";
import axios from '../../axios/axiosconf';
import { leadingZero, getHoraCita, getElementosHora, getAmpm, parseDateClickCalendario } from "../../../resources/Helper";
import { buildCitaTooltipHtml, calcularPosicionTooltipCita } from "../../../resources/agendaTooltipContent";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import AgendaTooltip from "../custom/AgendaTooltip";
import Unauthorized from "../general/Unauthorized";

/** Activar solo para depurar la agenda en desarrollo. En producción debe quedar en false. */
const DEBUG_AGENDA = false;
const agendaDebug = (...args) => {
    if (DEBUG_AGENDA) console.log(...args);
};
const agendaWarn = (...args) => {
    if (DEBUG_AGENDA) console.warn(...args);
};

function Agenda(props) {

    // const [showFormNuevaCita, setShowFormNuevaCita] = useState(false); // Eliminado por no usarse
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [citas, setCitas] = useState([]);
    const [extendedProps, setExtendedProps] = useState({});

    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');

    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [idConvenios, setIdConvenios] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [citaPaciente, setCitaPaciente] = useState('');

    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    /** Estado del paciente (tabla paciente.estado): 1 = anamnesis completa, 0 = pendiente (igual que ListaCitasDia). */
    const [estadoPaciente, setEstadoPaciente] = useState('');

    const [usuarioAsignaCita, setUsuarioAsignaCita] = useState('');
    const [nombreUsuarioAsignaCita, setNombreUsuarioAsignaCita] = useState('');

    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');

    const [primeraVez, setPrimeraVez] = useState();

    const [nuevoEstadoCita, setNuevoEstadoCita] = useState(props.nuevoEstadoCita);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        localStorage.removeItem('userAgenda');
        setShow(false);
    }

    const [msgReagendarCita, setMsgReagendarCita] = useState();
    const [showCitaDrop, setShowCitaDrop] = useState(false);

    const [idCitaDrop, setIdCitaDrop] = useState();
    const [fechaCitaDrop, setFechaCitaDrop] = useState();
    const [horaCitaDrop, setHoraCitaDrop] = useState();

    // Estados para horarios de agenda
    const [slotMinTime, setSlotMinTime] = useState('00:00:00');
    const [slotMaxTime, setSlotMaxTime] = useState('24:00:00');
    const [hasPermission, setHasPermission] = useState(null); // null = aún no validado
    const [calendarReady, setCalendarReady] = useState(false);
    const [estadoCitaDrop, setEstadoCitaDrop] = useState();
    const [duracionCitaDrop, setDuracionCitaDrop] = useState();
    const [fechaInicioOriginalCitaDrop, setFechaInicioOriginalCitaDrop] = useState();
    const [fechaInicioOriginalCitaDropStr, setFechaInicioOriginalCitaDropStr] = useState();
    const [fechaFinOriginalCitaDrop, setFechaFinOriginalCitaDrop] = useState();
    const [fechaFinOriginalCitaDropStr, setFechaFinOriginalCitaDropStr] = useState();
    const [idUsuarioReagenda, setIdUsuarioReagenda] = useState();

    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();

    const [tooltipTop, setTooltipTop] = useState();
    const [tooltipLeft, setTooltipLeft] = useState();
    const [tooltipDisplay, setTooltipDisplay] = useState();
    const [tooltipAnchor, setTooltipAnchor] = useState(null);
    const [contenidoTooltip, setContenidoTooltip] = useState('');

    const [estadoPorDefecto, setEstadoPorDefecto] = useState();
    const [permisos, setPermisos] = useState([]);
    const [stepCita, setStepCita] = useState();
    const [slotDuration, setSlotDuration] = useState('00:30:00');
    const [pendingFocus, setPendingFocus] = useState(null);
    const [highlightCitaId, setHighlightCitaId] = useState(null);

    const calendarRef = useRef();
    const eventDropInfoRef = useRef(null);
    const tooltipHideTimerRef = useRef(null);
    const highlightTimerRef = useRef(null);
    const pendingScrollRef = useRef(null);
    const onTituloFechaClickRef = useRef(null);
    const titleClickHandlerRef = useRef(null);
    /** Evita que irAFecha (sincronizado desde prev/next del calendario) fuerce gotoDate o vista Día. */
    const fechaSyncFromCalendarRef = useRef(false);
    const lastProcessedFocusTokenRef = useRef(0);
    const lastFechaNavigateTokenRef = useRef(0);
    const [bloquearEstadoCita, setBloquearEstadoCita] = useState(false);

    const formatFechaISO = (fecha) => {
        if (!fecha || Number.isNaN(fecha.getTime())) return '';
        return `${fecha.getFullYear()}-${leadingZero(fecha.getMonth() + 1)}-${leadingZero(fecha.getDate())}`;
    };

    const notificarFechaCalendario = (fechaIso, fromCalendarNav = false) => {
        if (fechaIso && typeof props.onFechaCalendarioChange === 'function') {
            if (fromCalendarNav) {
                fechaSyncFromCalendarRef.current = true;
            }
            props.onFechaCalendarioChange(fechaIso);
        }
    };

    const enlazarTituloCalendario = () => {
        if (typeof props.onTituloFechaClick !== 'function') return;

        const titleEl = calendarRef.current?.elRef?.current?.querySelector('.fc-toolbar-title')
            || document.querySelector('.agenda-fc-root .fc-toolbar-title');

        if (!titleEl) return;

        if (titleClickHandlerRef.current) {
            titleEl.removeEventListener('click', titleClickHandlerRef.current);
            titleEl.removeEventListener('keydown', titleClickHandlerRef.current);
        }

        titleEl.classList.add('agenda-fc-title-clickable');
        titleEl.setAttribute('role', 'button');
        titleEl.setAttribute('tabindex', '0');
        titleEl.setAttribute('title', 'Clic para cambiar fecha');

        if (!titleEl.querySelector('.agenda-fc-title-icon')) {
            const icon = document.createElement('i');
            icon.className = 'far fa-calendar-alt agenda-fc-title-icon';
            icon.setAttribute('aria-hidden', 'true');
            titleEl.prepend(icon);
        }

        const handler = (event) => {
            if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
            if (event.type === 'keydown') event.preventDefault();
            onTituloFechaClickRef.current?.();
        };

        titleClickHandlerRef.current = handler;
        titleEl.addEventListener('click', handler);
        titleEl.addEventListener('keydown', handler);
    };

    const clearTooltipHideTimer = () => {
        if (tooltipHideTimerRef.current) {
            clearTimeout(tooltipHideTimerRef.current);
            tooltipHideTimerRef.current = null;
        }
    };

    const clearHighlightTimer = () => {
        if (highlightTimerRef.current) {
            clearTimeout(highlightTimerRef.current);
            highlightTimerRef.current = null;
        }
    };

    const normalizeHoraScroll = (hora) => {
        if (!hora) return '';
        const raw = String(hora).trim();
        // Acepta "HH:mm" o "HH:mm:ss"
        if (/^\d{2}:\d{2}:\d{2}$/.test(raw)) return raw;
        if (/^\d{2}:\d{2}$/.test(raw)) return `${raw}:00`;
        return '';
    };

    const ejecutarScrollHora = (calendarApi, horaObjetivo) => {
        if (!calendarApi || !calendarApi.scrollToTime || !horaObjetivo) return;
        try {
            calendarApi.scrollToTime(horaObjetivo);
        } catch (error) {
            agendaWarn('No se pudo hacer scroll a hora objetivo:', error);
        }
    };

    let userdata = [];
    const agendaHistory = useHistory();

    const handleNuevaCita = () => {
        setShow(false);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: idPaciente
            }
        }

        axios.get('paciente', config)
            .then(response => {
                //console.log(response.data);
                setPrimerNombre(response.data[0].primer_nombre);
                setSegundoNombre(response.data[0].segundo_nombre);
                setPrimerApellido(response.data[0].primer_apellido);
                setSegundoApellido(response.data[0].segundo_apellido);
                setEmail(response.data[0].email);
                setCelular(response.data[0].celular);
                setTipoDocumento(response.data[0].tipo_documento);
                setNumeroDocumento(response.data[0].numero_documento);
                setIdPaciente(idPaciente);
                //setModalState('visible');
                agendaHistory.push('/agenda-profesional');
            })
            .catch(error => {
                agendaDebug(error);
            })
    }


    const calendarClick = (info) => {
        const fechaISO = parseDateClickCalendario(info);
        const fechaCita = formatFechaISO(fechaISO);

        // Vista mensual: solo clic en el número del día → vista diaria; espacio en blanco → nueva cita
        if (info.view?.type === 'dayGridMonth') {
            const clicEnNumero = info.jsEvent?.target?.closest?.('.fc-daygrid-day-number');
            if (clicEnNumero) {
                try {
                    const calendarApi = calendarRef.current?.getApi();
                    if (calendarApi) {
                        calendarApi.changeView('timeGridDay', fechaCita);
                    }
                } catch (error) {
                    agendaWarn('Error al cambiar a vista Día desde mes:', error);
                }
                notificarFechaCalendario(fechaCita, true);
                return;
            }
        }

        if (permisos.includes('crearCitas')) {
            const horaCita = leadingZero(fechaISO.getHours()) + ':' + leadingZero(fechaISO.getMinutes()) + ':00';

            setDate(fechaCita);
            setTime(horaCita);
            setExtendedProps(null);

            setHoraAtencionCita(getHoraCita(fechaISO.getHours()));
            setMinutoCita(leadingZero(fechaISO.getMinutes()));
            setAmpmCita(getAmpm(fechaISO.getHours()));

            setIdCita('');
            setPrimerNombre('');
            setSegundoNombre('');
            setPrimerApellido('');
            setSegundoApellido('');
            setEmail('');
            setCelular('');
            setTipoDocumento('');
            setNumeroDocumento('');

            setDuracionCita('');
            setEstadoCita('');
            setIdEstadoCita('');
            setUnidadAtencion('');
            setIdConvenios('');
            setMotivoConsulta('');
            setCitaPaciente('');

            setVerCita(false);
            setPrimeraVez(true);
            setEstadoPaciente('');
            setUsuarioAsignaCita('');
            setNombreUsuarioAsignaCita('');

            setBloquearEstadoCita(true);
            //setIdEstadoCita(1);
            setEstadoPorDefecto('asignada');

            setModalState('visible');
        }
    }


    function clicCita(e) {
        setDate(e.event.extendedProps.fecha_cita);
        setTime(e.event.extendedProps.hora_cita);

        const _citaPac = (e.event.extendedProps.cita_paciente || '').trim();
        const _idPaciente = e.event.extendedProps.id_paciente;
        const _primerNombre = e.event.extendedProps.primer_nombre;

        // Cita simple (sin ficha): un solo campo de asunto; ignorar nombres partidos en la fila cita.
        if (_citaPac && !_idPaciente) {
            setPrimerNombre(_citaPac);
            setSegundoNombre('');
            setPrimerApellido('');
            setSegundoApellido('');
        } else {
            setPrimerNombre(_primerNombre || _citaPac);
            setSegundoNombre(e.event.extendedProps.segundo_nombre);
            setPrimerApellido(_primerNombre ? e.event.extendedProps.primer_apellido : '');
            setSegundoApellido(e.event.extendedProps.segundo_apellido);
        }
        // Si existe info en tabla citas, priorizarla para mantener contexto de la cita.
        setEmail(e.event.extendedProps.cita_email || e.event.extendedProps.email);
        setCelular(e.event.extendedProps.cita_celular || e.event.extendedProps.cita_telefono || e.event.extendedProps.celular);
        setTipoDocumento(e.event.extendedProps.tipo_documento);
        setNumeroDocumento(e.event.extendedProps.numero_documento);
        setIdPaciente(e.event.extendedProps.id_paciente);
        setCitaPaciente(e.event.extendedProps.cita_paciente || '');

        const _estPac = e.event.extendedProps.estado;
        setEstadoPaciente(_estPac !== undefined && _estPac !== null && _estPac !== '' ? String(_estPac) : '');

        setDuracionCita(e.event.extendedProps.duracion_cita);
        setEstadoCita(e.event.extendedProps.estado_cita);
        setIdEstadoCita(e.event.extendedProps.id_estado_cita);
        setUnidadAtencion(e.event.extendedProps.id_unidad_atencion);
        setIdConvenios(e.event.extendedProps.id_convenios != null && e.event.extendedProps.id_convenios !== ''
            ? String(e.event.extendedProps.id_convenios)
            : '');

        // Mantener motivo de consulta tal cual fue guardado.
        // Si no existe, mostrar vacío (sin heredar nombre/asunto).
        setMotivoConsulta(e.event.extendedProps.motivo_consulta || '');
        setVerCita(true);
        setPrimeraVez(false);

        setIdCita(e.event.extendedProps.id_cita);

        setUsuarioAsignaCita(e.event.extendedProps.id_usuario_asigna || '');
        setNombreUsuarioAsignaCita(
            [e.event.extendedProps.nombre_usuario_agenda, e.event.extendedProps.apellido_usuario_agenda]
                .filter(Boolean)
                .join(' ')
                .trim()
        );

        setHoraAtencionCita(getElementosHora(e.event.extendedProps.hora_cita)[0]);
        setMinutoCita(getElementosHora(e.event.extendedProps.hora_cita)[1]);
        setAmpmCita(getElementosHora(e.event.extendedProps.hora_cita)[2]);

        setBloquearEstadoCita(false);

        // Mostrar botón "Atender" según el campo mostrar_atencion del estado de la cita
        // (independiente de si la cita tiene id_paciente vinculado o no)
        if (e.event.extendedProps.mostrar_atencion == 1) {
            setPuedeAtender(true);
        } else {
            setPuedeAtender(false);
        }

        if (e.event.extendedProps.estado_cita != null) {
            setModalState('visible');
        }
    }


    const revertEventoArrastrado = () => {
        const dropInfo = eventDropInfoRef.current;
        if (dropInfo && typeof dropInfo.revert === 'function') {
            try {
                dropInfo.revert();
            } catch (error) {
                agendaWarn('No se pudo revertir el arrastre de la cita:', error);
            }
        }
        eventDropInfoRef.current = null;
    };

    function handleCitaDrop(info) {
        eventDropInfoRef.current = info;

        const fechaISO = info.event.start instanceof Date ? info.event.start : new Date(info.event.start);
        const fechaCita = fechaISO.getFullYear() + '-' + leadingZero(fechaISO.getMonth() + 1) + '-' + leadingZero(fechaISO.getDate());
        const horaCita = leadingZero(fechaISO.getHours()) + ':' + leadingZero(fechaISO.getMinutes()) + ':00';

        setMsgReagendarCita('¿Confirmas el reagendamiento de la cita para el ' + fechaCita + ' a las ' + horaCita + '?');
        setShowCitaDrop(true);

        setIdCitaDrop(info.oldEvent.extendedProps.id_cita);
        setFechaCitaDrop(fechaCita);
        setHoraCitaDrop(horaCita);
        setEstadoCitaDrop(info.oldEvent.extendedProps.id_estado_cita);
        setDuracionCitaDrop(info.oldEvent.extendedProps.duracion_cita);
        clearTooltipHideTimer();
        setTooltipDisplay('none');

        setFechaInicioOriginalCitaDrop(info.oldEvent.start);
        setFechaFinOriginalCitaDrop(info.oldEvent.end);
        setFechaInicioOriginalCitaDropStr(info.oldEvent.startStr);
        setFechaFinOriginalCitaDropStr(info.oldEvent.endStr);
        setIdUsuarioReagenda(info.oldEvent.extendedProps.id_users);
    }

    function handleReagendarCita() {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            uid: userdata.user_id,
            id: idCitaDrop,
            fecha_cita: fechaCitaDrop,
            hora_cita: horaCitaDrop,
            estado_cita: estadoCitaDrop,
            duracion_cita: duracionCitaDrop,
            hora_atencion_cita: '1',
            minuto_cita: '0',
            ampm: 'am',
            id_users: idUsuarioAgenda
        }

        axios.put('cita', config)
            .then(response => {
                if (response.status === 200) {
                    eventDropInfoRef.current = null;
                    getCitas2();
                }
            })
            .catch(error => {
                agendaDebug(error);
                revertEventoArrastrado();
            })
            .finally(() => {
                setShowCitaDrop(false);
            });
    }


    const handleCloseCitaDrop = () => {
        revertEventoArrastrado();
        setShowCitaDrop(false);
        getCitas2();
    }


    function handleMouseEnter(info) {
        clearTooltipHideTimer();

        const elemRect = info.el.getBoundingClientRect();
        const esBloqueo = Boolean(info.event.extendedProps?.bloqueo);
        const pos = calcularPosicionTooltipCita(elemRect, { esBloqueo });
        const contenidott = buildCitaTooltipHtml(info.event);

        setTooltipAnchor(elemRect);
        setContenidoTooltip(contenidott);
        setTooltipTop(pos.top);
        setTooltipLeft(pos.left);
        setTooltipDisplay('block');
    }

    function handleMouseLeave() {
        clearTooltipHideTimer();
        tooltipHideTimerRef.current = setTimeout(() => {
            setTooltipDisplay('none');
            setTooltipAnchor(null);
            tooltipHideTimerRef.current = null;
        }, 220);
    }

    useEffect(() => () => {
        clearTooltipHideTimer();
        clearHighlightTimer();
    }, []);

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));

            // 🔒 VALIDACIÓN DE PERMISOS HÍBRIDA - Verificar acceso a ver agenda
            let tienePermiso = false;
            
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                tienePermiso = userdata.permissions.some(permission => permission.slug === 'verAgenda');
            } else if (userdata.up && userdata.up.includes('verAgenda')) {
                tienePermiso = true;
            }

            if (!tienePermiso) {
                setHasPermission(false);
                return; // Detener ejecución si no tiene permisos
            }

            setHasPermission(true);

            setStepCita(userdata.step);
            setSlotDuration('00:' + userdata.step + ':00');
            setPermisos(userdata.up || []);
        }

        // ✅ Cargar horarios de agenda
        axios.get('/horario-agenda')
            .then(response => {
                if (response.status === 200) {
                    // Si es el rango por defecto (00:00:00 - 23:59:00), usar 24 horas completas
                    if (response.data.hora_inicio === '00:00:00' && response.data.hora_fin === '23:59:00') {
                        setSlotMinTime('00:00:00');
                        setSlotMaxTime('24:00:00');
                    } else {
                        // FullCalendar usa slotMaxTime como límite exclusivo
                        // Agregar 30 minutos para incluir la última hora completa
                        const horaFin = response.data.hora_fin.split(':');
                        const horas = parseInt(horaFin[0]);
                        const minutos = parseInt(horaFin[1]);
                        
                        // Calcular nueva hora fin con 30 minutos adicionales
                        let nuevosMinutos = minutos + 30;
                        let nuevasHoras = horas;
                        
                        if (nuevosMinutos >= 60) {
                            nuevosMinutos -= 60;
                            nuevasHoras += 1;
                        }
                        
                        const horaFinAjustada = `${String(nuevasHoras).padStart(2, '0')}:${String(nuevosMinutos).padStart(2, '0')}:00`;
                        
                        setSlotMinTime(response.data.hora_inicio);
                        setSlotMaxTime(horaFinAjustada);
                    }
                }
            })
            .catch(error => {
                agendaDebug('Usando horarios por defecto (24h)');
                // Mantener valores por defecto si hay error
            });

        // 🔒 Validar que el calendario esté montado antes de acceder a la API
        if (calendarRef.current) {
            try {
                let calendarApi = calendarRef.current.getApi();
                let currentTime = new Date();

                setCalendarReady(true); // Marcar calendario como listo

                setTimeout(() => {
                    if (calendarApi && calendarApi.scrollToTime) {
                        calendarApi.scrollToTime(currentTime.getHours() + ':00');
                    }
                }, 300);
            } catch (error) {
                agendaWarn('Error Al Configurar El Scroll Del Calendario:', error);
            }
        }
    }, [calendarReady]);


    useEffect(() => {

        if (extendedProps) {
            getCitas();
        }

    }, [extendedProps]);

    useEffect(() => {
        setIdUsuarioAgenda(props.profesionalAsignado);
    }, [props.profesionalAsignado]);

    useEffect(() => {
        setIdUnidadAgenda(props.unidad);
    }, [props.unidad]);

    useEffect(() => {
        // una sola función para cargar citas de forma reactiva
        getCitas2();
    }, [idUsuarioAgenda, idUnidadAgenda, props.citaAgendada]);



    useEffect(() => {
        if (props.agendarCitaPaciente != null) {
            //setModalState('visible');
            setIdPaciente(props.agendarCitaPaciente);
            setShow(true);
        }
    }, [props.agendarCitaPaciente]);


    useEffect(() => {
        setNuevoEstadoCita(props.estadoNuevaCita);
    }, [props.estadoNuevaCita]);

    useEffect(() => {
        onTituloFechaClickRef.current = props.onTituloFechaClick;
    }, [props.onTituloFechaClick]);

    useEffect(() => {
        if (!calendarRef.current || !props.irAFecha) return;

        const token = props.irAFechaToken ?? 0;
        const forceFromParent = token !== lastFechaNavigateTokenRef.current;

        if (forceFromParent) {
            lastFechaNavigateTokenRef.current = token;
            fechaSyncFromCalendarRef.current = false;
        } else if (fechaSyncFromCalendarRef.current) {
            fechaSyncFromCalendarRef.current = false;
            return;
        }

        try {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(props.irAFecha);
            if (calendarApi.view?.type !== 'timeGridDay') {
                calendarApi.changeView('timeGridDay', props.irAFecha);
            }
        } catch (error) {
            agendaWarn('Error Al Navegar A La Fecha En El Calendario:', error);
        }
    }, [props.irAFecha, props.irAFechaToken, calendarReady]);

    // Forzar vista Día al venir del buscador (token cambia en cada selección).
    useEffect(() => {
        if (!calendarRef.current || !props.irAFocusToken || !props.irAFecha) return;
        try {
            const calendarApi = calendarRef.current.getApi();
            // Doble intento para evitar que el render de FullCalendar deje la vista anterior.
            calendarApi.changeView('timeGridDay', props.irAFecha);
            setTimeout(() => calendarApi.changeView('timeGridDay', props.irAFecha), 80);
        } catch (error) {
            agendaWarn('Error al forzar vista Día desde buscador:', error);
        }
    }, [props.irAFocusToken, props.irAFecha]);

    // Enfoque desde buscador: solo cuando cambia irAFocusToken (no al sincronizar fecha con prev/next).
    useEffect(() => {
        if (!props.irAFocusToken || props.irAFocusToken === lastProcessedFocusTokenRef.current) return;
        if (!props.irAFecha) return;
        lastProcessedFocusTokenRef.current = props.irAFocusToken;
        setPendingFocus({
            token: props.irAFocusToken,
            fecha: props.irAFecha,
            hora: props.irAHora || '',
            idCita: props.irACitaId || null
        });
    }, [props.irAFocusToken, props.irAFecha, props.irAHora, props.irACitaId]);

    // Ejecutar enfoque cuando el calendario y las citas estén listos.
    useEffect(() => {
        if (!pendingFocus || !calendarRef.current) return;

        try {
            const calendarApi = calendarRef.current.getApi();
            // Para facilitarle al usuario, siempre mostrar la cita en vista Día al venir del buscador.
            if (calendarApi.view?.type !== 'timeGridDay') {
                calendarApi.changeView('timeGridDay', pendingFocus.fecha);
            } else {
                calendarApi.gotoDate(pendingFocus.fecha);
            }

            const horaObjetivo = normalizeHoraScroll(pendingFocus.hora);
            if (horaObjetivo) {
                pendingScrollRef.current = {
                    hora: horaObjetivo,
                    expiresAt: Date.now() + 1800
                };
                // Scroll en varios ciclos para garantizar que aplique tras el re-render del calendario.
                ejecutarScrollHora(calendarApi, horaObjetivo);
                setTimeout(() => ejecutarScrollHora(calendarApi, horaObjetivo), 120);
                setTimeout(() => ejecutarScrollHora(calendarApi, horaObjetivo), 320);
            }

            if (pendingFocus.idCita) {
                const eventos = calendarApi.getEvents();
                const eventoObjetivo = eventos.find((ev) => {
                    const idExt = ev.extendedProps?.id_cita;
                    return String(idExt) === String(pendingFocus.idCita) || String(ev.id) === String(pendingFocus.idCita);
                });

                if (eventoObjetivo) {
                    const idEvento = eventoObjetivo.extendedProps?.id_cita ?? eventoObjetivo.id;
                    setHighlightCitaId(String(idEvento));
                    clearHighlightTimer();
                    highlightTimerRef.current = setTimeout(() => setHighlightCitaId(null), 1200);
                    // Abrir la cita para dejarla en primer plano.
                    clicCita({ event: eventoObjetivo });
                }
            }
        } catch (error) {
            agendaWarn('Error al enfocar cita desde buscador:', error);
        } finally {
            setPendingFocus(null);
        }
    }, [pendingFocus, citas]);





    function getCitas() {

        // ✅ Solo cargar citas si hay una agenda seleccionada
        if (!idUsuarioAgenda || idUsuarioAgenda === '24' || idUsuarioAgenda === 24) {
            agendaDebug('No hay agenda seleccionada, saltando carga de citas');
            setCitas([]);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/citas-profesional', config)
            .then(response => {
                setCitas(response.data);
            })
            .catch(error => {
                agendaDebug(error.response?.message);
                setCitas([]);
            })
    }


    function getCitas2() {

        props.citaAgendada();

        // ✅ Solo cargar citas si hay una agenda seleccionada
        if (!idUsuarioAgenda || idUsuarioAgenda === '24' || idUsuarioAgenda === 24) {
            agendaDebug('No hay agenda seleccionada, saltando carga de citas');
            setCitas([]);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: idUsuarioAgenda
            }
        }

        agendaDebug('Cargando citas para agenda:', idUsuarioAgenda, 'unidad:', idUnidadAgenda || 'todas');

        axios.get('/citas-profesional', config)
            .then(response => {
                const citasAgenda = Array.isArray(response.data) ? response.data : [];
                const citasFiltradas = idUnidadAgenda
                    ? citasAgenda.filter((cita) => {
                        const unidadCita = cita?.extendedProps?.id_unidad_atencion;
                        return String(unidadCita ?? '') === String(idUnidadAgenda);
                    })
                    : citasAgenda;

                setCitas(citasFiltradas);
                agendaDebug('Citas cargadas:', citasFiltradas.length);
            })
            .catch(error => {
                agendaDebug('Error cargando citas:', error.response?.status, error.response?.data);
                setCitas([]);
            })
    }


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    // ⏳ Mientras valida permisos, no mostrar nada (evita flash del modal)
    if (hasPermission === null) {
        return null;
    }

    return (
        <div className="agenda-fc-root">
            <style>{`
                @media (max-width: 767.98px) {
                    /* Grid evita que estilos globales mantengan el toolbar en una fila y superpongan
                       el bloque Mes/Semana/Día sobre el título (orden DOM: izq | centro | der). */
                    .agenda-fc-root .fc .fc-toolbar.fc-header-toolbar {
                        display: grid !important;
                        grid-template-columns: 1fr;
                        grid-template-areas:
                            "fc-nav"
                            "fc-title"
                            "fc-views";
                        align-items: stretch;
                        justify-content: stretch;
                        gap: 10px;
                        margin-bottom: 0.75em !important;
                        overflow: visible;
                    }
                    .agenda-fc-root .fc .fc-toolbar.fc-header-toolbar > .fc-toolbar-chunk:nth-child(1) {
                        grid-area: fc-nav;
                    }
                    .agenda-fc-root .fc .fc-toolbar.fc-header-toolbar > .fc-toolbar-chunk:nth-child(2) {
                        grid-area: fc-title;
                    }
                    .agenda-fc-root .fc .fc-toolbar.fc-header-toolbar > .fc-toolbar-chunk:nth-child(3) {
                        grid-area: fc-views;
                    }
                    .agenda-fc-root .fc .fc-toolbar-chunk {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-items: center;
                        gap: 6px;
                        row-gap: 8px;
                        width: 100%;
                        min-width: 0;
                    }
                    .agenda-fc-root .fc .fc-toolbar-title {
                        /* custom.css (≤480px) pone el título absolute y choca con Mes/Semana/Día */
                        position: static !important;
                        top: auto !important;
                        left: auto !important;
                        right: auto !important;
                        font-size: 1.05rem !important;
                        line-height: 1.35 !important;
                        white-space: normal !important;
                        text-align: center;
                        padding: 4px 8px 2px !important;
                        margin: 0 auto !important;
                        overflow: visible !important;
                        max-width: 100%;
                    }
                    .agenda-fc-root .fc .fc-button {
                        padding: 0.35em 0.55em;
                        font-size: 0.8rem;
                    }
                }
                .agenda-fc-root .fc .fc-toolbar-chunk:nth-child(2) {
                    display: flex;
                    justify-content: center;
                }
                .agenda-fc-root .fc .fc-toolbar-title.agenda-fc-title-clickable {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 0.32rem 0.75rem;
                    border-radius: 999px;
                    border: 1px solid rgba(23, 162, 184, 0.25);
                    background: rgba(23, 162, 184, 0.08);
                    color: #17a2b8;
                    font-size: 1rem;
                    font-weight: 600;
                    letter-spacing: 0.01em;
                    cursor: pointer;
                    transition: all 0.16s ease;
                }
                .agenda-fc-root .fc .fc-toolbar-title.agenda-fc-title-clickable .agenda-fc-title-icon {
                    font-size: 0.92em;
                }
                .agenda-fc-root .fc .fc-toolbar-title.agenda-fc-title-clickable:hover,
                .agenda-fc-root .fc .fc-toolbar-title.agenda-fc-title-clickable:focus {
                    background: rgba(23, 162, 184, 0.14);
                    color: #138496;
                    transform: translateY(-1px);
                    outline: none;
                    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.2);
                }
                .agenda-fc-root .fc-dayGridMonth-view .fc-daygrid-day-number {
                    cursor: pointer;
                    position: relative;
                    z-index: 2;
                }
                .agenda-fc-root .fc-dayGridMonth-view .fc-daygrid-day-number:hover {
                    color: #17a2b8;
                    text-decoration: underline;
                }
                .agenda-fc-root .fc-dayGridMonth-view .fc-daygrid-day-frame {
                    cursor: default;
                }
                .agenda-fc-root .fc-timeGridWeek-view .agenda-week-event {
                    display: flex;
                    flex-direction: row;
                    align-items: baseline;
                    gap: 4px;
                    min-width: 0;
                    width: 100%;
                    overflow: hidden;
                    line-height: 1.15;
                }
                .agenda-fc-root .fc-timeGridWeek-view .agenda-week-event .fc-event-time {
                    flex: 0 0 auto;
                    font-size: 0.72em;
                    opacity: 0.92;
                    white-space: nowrap;
                }
                .agenda-fc-root .fc-timeGridWeek-view .agenda-week-event .fc-event-title {
                    flex: 1 1 auto;
                    min-width: 0;
                    font-weight: 600;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            `}</style>
            <FullCalendar
                plugins={[daygridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="timeGridDay"
                locale={esLocale}
                allDaySlot={false}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }}

                dateClick={calendarClick}
                events={citas}
                eventClick={clicCita}
                editable={true}
                eventDrop={handleCitaDrop}
                eventMouseEnter={handleMouseEnter}
                eventMouseLeave={handleMouseLeave}
                eventClassNames={(arg) => {
                    const eventId = arg.event.extendedProps?.id_cita ?? arg.event.id;
                    return highlightCitaId && String(eventId) === String(highlightCitaId)
                        ? ['fc-event-search-highlight']
                        : [];
                }}
                eventDragStart={() => {
                    clearTooltipHideTimer();
                    setTooltipDisplay('none');
                }}
                datesSet={(dateInfo) => {
                    if (dateInfo?.view?.type === 'timeGridDay' && calendarRef.current) {
                        try {
                            const fechaDia = calendarRef.current.getApi().getDate();
                            notificarFechaCalendario(formatFechaISO(fechaDia), true);
                        } catch (error) {
                            agendaWarn('Error sincronizando fecha en vista día:', error);
                        }
                    } else if (dateInfo?.view?.type === 'timeGridWeek' && calendarRef.current) {
                        try {
                            const fechaSemana = calendarRef.current.getApi().getDate();
                            notificarFechaCalendario(formatFechaISO(fechaSemana), true);
                        } catch (error) {
                            agendaWarn('Error sincronizando fecha en vista semana:', error);
                        }
                    } else if (dateInfo?.view?.type === 'dayGridMonth' && dateInfo.start) {
                        notificarFechaCalendario(formatFechaISO(dateInfo.start), true);
                    }

                    requestAnimationFrame(() => enlazarTituloCalendario());

                    if (!calendarRef.current || !pendingScrollRef.current) return;
                    const { hora, expiresAt } = pendingScrollRef.current;
                    if (Date.now() > expiresAt) {
                        pendingScrollRef.current = null;
                        return;
                    }
                    try {
                        const api = calendarRef.current.getApi();
                        ejecutarScrollHora(api, hora);
                    } catch (error) {
                        agendaWarn('Error aplicando scroll en datesSet:', error);
                    }
                }}
                eventOverlap={false}
                ref={calendarRef}
                slotDuration={slotDuration}
                slotLabelInterval={slotDuration}
                height={'70vh'}
                slotMinTime={slotMinTime}
                slotMaxTime={slotMaxTime}

                slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short',
                    hour12: true
                }}
                eventTimeFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: false,
                    hour12: true
                }}
                eventContent={(arg) => {
                    if (arg.view.type !== 'timeGridWeek') {
                        return;
                    }

                    const start = arg.event.start;
                    let horaCorta = '';
                    if (start) {
                        const h = start.getHours();
                        const m = start.getMinutes();
                        const h12 = h % 12 || 12;
                        horaCorta = `${h12}:${String(m).padStart(2, '0')}`;
                    }

                    const esc = (s) => String(s || '')
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;');

                    const nombre = arg.event.title || '';
                    return {
                        html: `<div class="fc-event-main-frame agenda-week-event"><div class="fc-event-time">${esc(horaCorta)}</div><div class="fc-event-title">${esc(nombre)}</div></div>`,
                    };
                }}
            >

            </FullCalendar>

            <FormNuevaCita
                modalState={modalState}
                closeModal={modalState => setModalState('hidden')}
                profesionalAsignado={props.profesionalAsignado}
                nombreProfesionalAsignado={props.nombreProfesionalAsignado}
                usuarioAsigna={verCita ? usuarioAsignaCita : ''}
                nombreUsuarioAsigna={verCita ? nombreUsuarioAsignaCita : ''}
                fecha={date}
                hora={time}
                reloadCitas={getCitas}
                reloadCitasAgenda={getCitas2}
                extendedProps={extendedProps}
                primerNombre={primerNombre}
                segundoNombre={segundoNombre}
                primerApellido={primerApellido}
                segundoApellido={segundoApellido}
                email={email}
                celular={celular}
                tipoDocumento={tipoDocumento}
                numeroDocumento={numeroDocumento}
                duracionCita={duracionCita}
                estadoCita={idEstadoCita}
                unidadAtencion={unidadAtencion}
                idConvenios={idConvenios}
                motivoConsulta={motivoConsulta}
                citaPaciente={citaPaciente}
                verCita={verCita}
                puedeAtender={puedeAtender}
                estadoPaciente={estadoPaciente}
                idPaciente={idPaciente}
                primeraVez={primeraVez}
                idCita={idCita}

                horaAtencionCita={horaAtencionCita}
                minutoCita={minutoCita}
                ampmCita={ampmCita}

                agendarCitaPaciente={props.agendarCitaPaciente}
                bloquearProfesional={props.bloquearProfesional}
                bloquearEstadoCita={bloquearEstadoCita}
                stepCita={stepCita}
                estadoPorDefecto={estadoPorDefecto}

            />

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Cita {nuevoEstadoCita}</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Deseas Asignar Otra Cita Para Este Paciente?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>No</Button>
                    <Button variant="primary" onClick={handleNuevaCita}>Si</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCitaDrop} onHide={handleCloseCitaDrop}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Reagendamiento</Modal.Title>
                </Modal.Header>
                <Modal.Body>{msgReagendarCita}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCitaDrop}>No</Button>
                    <Button variant="primary" onClick={handleReagendarCita}>Si</Button>
                </Modal.Footer>
            </Modal>

            <AgendaTooltip
                top={tooltipTop}
                left={tooltipLeft}
                display={tooltipDisplay}
                contenido={contenidoTooltip}
                anchorRect={tooltipAnchor}
            />
        </div>
    );
}
export default Agenda;